/**
 * 下拉选择预设配置
 *  COMPARE
 *  GENDER
 *  TIME_POINT
 *  TIME_POINT_SIMPLE
 *  LOGIC
 *  SESSION_TYPE
 *  AGE
 *  EDUCATION
 *  TIME_RANG_A
 */

// 错误状态
const ERROR = [
  {
    text: 'type不可以设置为空',
    value: 0,
  },
];

// 数学比较
const COMPARE = [
  {
    text: '是',
    value: '==',
  },
  {
    text: '不是',
    value: '!=',
  },
  {
    text: '大于',
    value: '>',
  },
  {
    text: '小于',
    value: '<',
  },
  {
    text: '大于等于',
    value: '>=',
  },
  {
    text: '小于等于',
    value: '<=',
  },
  {
    text: '之间',
    value: 'between',
  },
];

// 简易版时间点
// 这里按照交互要求，为了客户容易理解，将之间改为了是
const TIME_POINT_SIMPLE = [
  {
    text: '是',
    value: '==',
  },
  {
    text: '早于',
    value: '<',
  },
  {
    text: '晚于',
    value: '>',
  },
];

// 逻辑比较
const LOGIC = [
  {
    text: '是',
    value: '==',
  },
  {
    text: '不是',
    value: '!=',
  },
  {
    text: '包含', // 字符串类型为 contains
    value: 'arrayInclude',
  },
  {
    text: '不包含', // 字符串类型为 !contains
    value: '!arrayInclude',
  },
];
// 学历的逻辑
const EDUCATION_LOGIC = [
  {
    text: '是',
    value: '==',
  },
  {
    text: '不是',
    value: '!=',
  },
];
// 时间点
const TIME_POINT = [
  {
    text: '早于',
    value: '<',
  },
  {
    text: '晚于',
    value: '>',
  },
  {
    text: '等于',
    value: '==',
  },
  {
    text: '之间',
    value: 'between',
  },
];

// 性别
const GENDER = [
  {
    text: '未知',
    value: 0,
  },
  {
    text: '男',
    value: 1,
  },
  {
    text: '女',
    value: 2,
  },
];

// 会话类型
const SESSION_TYPE = [
  {
    text: 'QQ会话',
    value: 1,
  },
  {
    text: '网页会话',
    value: 4,
  },
  {
    text: '微信公众号会话',
    value: 3,
  },
  {
    text: '微信小程序会话',
    value: 7,
  },
  {
    text: '微信客服会话',
    value: 53,
  },
];
const { data } = window;

if (data && data.data && !data.data.hasQQEntry) {
  SESSION_TYPE.splice(0, 1);
}
// 年龄段
const AGE = [
  {
    text: '未知',
    value: 0,
  },
  {
    text: '少年(18岁以下)',
    value: 1,
  },
  {
    text: '青年(18-30岁)',
    value: 2,
  },
  {
    text: '中年(30-50岁)',
    value: 3,
  },
  {
    text: '老年(50岁以上)',
    value: 4,
  },
];

// 学历
const EDUCATION = [
  {
    text: '未知',
    value: 0,
  },
  {
    text: '小学',
    value: 1,
  },
  {
    text: '初中',
    value: 2,
  },
  {
    text: '高中',
    value: 3,
  },
  {
    text: '大专',
    value: 4,
  },
  {
    text: '大学',
    value: 5,
  },
  {
    text: '研究生',
    value: 6,
  },
];

// 时长配置方案A
const TIME_RANG_A = [
  {
    text: '7天内',
    value: 0,
  },
  {
    text: '8-14天内',
    value: 1,
  },
  {
    text: '15-30天内',
    value: 2,
  },
  {
    text: '30天以上',
    value: 3,
  },
  {
    text: '不限',
    value: 4,
  },
];

export default {
  ERROR,
  COMPARE,
  GENDER,
  TIME_POINT,
  TIME_POINT_SIMPLE,
  LOGIC,
  SESSION_TYPE,
  AGE,
  EDUCATION,
  EDUCATION_LOGIC,
  TIME_RANG_A,
};
